import { PayloadAction, createAction, createSlice } from "@reduxjs/toolkit";
import { UserNotification } from "@onmo/graphql/graphql";

interface IInAppNotification {
  notiState: "show" | "close" | "fadeOut";
  appUpdated: boolean;
  data: UserNotification | null;
  queue: UserNotification[];
}

const initialState = {
  notiState: "close",
  appUpdated: false,
  data: null,
  queue: [],
} as IInAppNotification;

export const resetInAppNotificationState = createAction(
  "inAppNotification/resetState",
);

export const inAppNotificationSlice = createSlice({
  name: "inAppNotification",
  initialState: initialState,
  reducers: {
    setNotification: (
      state,
      action: PayloadAction<{ data?: UserNotification }>,
    ) => {
      if (!action.payload.data) return;
      if (state.notiState === "show") {
        // if notification is showing, add new notification to queue
        state.queue = [...state.queue, action.payload.data];
      } else {
        state.data = action.payload.data;
        state.notiState = "show";
        state.queue = state.queue.slice(1);
      }
    },
    setAppUpdated: (state, action: PayloadAction<{ appUpdated: boolean }>) => {
      state.appUpdated = action.payload.appUpdated;
    },
    closeNotification: (state) => {
      state.notiState = "close";
      state.data = null;
    },
    hideNotification: (state) => {
      state.notiState = "fadeOut";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetInAppNotificationState, () => initialState);
  },
});

// Action creators are generated for each case reducer function
export const {
  setNotification,
  closeNotification,
  hideNotification,
  setAppUpdated,
} = inAppNotificationSlice.actions;

export default inAppNotificationSlice.reducer;
